export default __webpack_public_path__ + "static/media/VISION-ETH.8db9f1be.png";